import Layout from './layout'

export default [
  // 品库编辑
  {
    path: '/dataStatistics',
    component: Layout,
    alwaysShow: true,
    meta: { groupTitle: '品库后台', title: '数据统计', icon: 'data_statistics', roles: ['admin'] },
    children: [
      {
        path: 'user-list',
        name: 'userList',
        component: () => import(/* webpackChunkName: "userList" */ '@v/dataStatistics/userList'),
        meta: { title: '用户列表' },
      },
      {
        path: 'consumption-list',
        name: 'consumptionList',
        component: () => import(/* webpackChunkName: "consumptionList" */ '@v/dataStatistics/consumptionList'),
        meta: { title: '消费统计' },
      },
      {
        path: 'recharge',
        name: 'recharge',
        component: () => import(/* webpackChunkName: "consumptionList" */ '@v/dataStatistics/recharge'),
        meta: { title: '充值统计' },
      },
      {
        path: 'plugin',
        name: 'DataStatisticsPlugin',
        component: () => import(/* webpackChunkName: "consumptionList" */ '@v/dataStatistics/plugin'),
        meta: { title: '插件销量统计' },
      },
    ],
  },
]
